import { render, staticRenderFns } from "./DocumentActionContainerCard.vue?vue&type=template&id=44b5b677&scoped=true&lang=pug"
import script from "./DocumentActionContainerCard.vue?vue&type=script&lang=ts"
export * from "./DocumentActionContainerCard.vue?vue&type=script&lang=ts"
import style0 from "./DocumentActionContainerCard.vue?vue&type=style&index=0&id=44b5b677&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5b677",
  null
  
)

export default component.exports